// import { message } from "antd";
import axios from "axios";
import { BaseURL, EmployeeID } from "configs/AppConfig";
import AuthService from "services/AuthService";

axios.defaults.baseURL = BaseURL;

axios.interceptors.request.use(
  async (config) => {
    // Fetch the bearer token from local storage
    const bearerToken = localStorage.getItem("bearerToken");

    config.headers.Authorization = `Bearer ${bearerToken}`;
    config.headers.Accept = "application/json";
    config.headers["Accrue-Client"] = "AdminPanel";
    config.headers.EmployeeID = EmployeeID;

    // Initialize or increment retry count on this request
    config.retryCount = config.retryCount || 0;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (res) => res,
  async (error) => {
    if (error.response && error.response.status === 401) {
      // If response is 401, increment retry count
      error.config.retryCount++;

      // If more than three attempts, sign out
      if (error.config.retryCount > 3) {
        localStorage.setItem("Permissions", JSON.stringify(null));
        // AuthService.signOut();
        return Promise.reject(error);
      }

      // Refresh the token
      await AuthService.refreshToken();

      // Fetch the new bearer token from local storage
      const newBearerToken = localStorage.getItem("bearerToken");

      // Update the Authorization header
      error.config.headers.Authorization = `Bearer ${newBearerToken}`;

      // Retry the API call
      return axios(error.config);
    } else {
      console.log(error);
      AuthService.statusHandler(error.response);
      return Promise.reject(error);
    }
  }
);
